module.exports = __webpack_public_path__ + "static/media/kitty7.fc861305.jpeg";